<template>
  <div class="">
    <div>
      <b-tabs content-class="pt-1" lazy v-model="tabIndex">
        <b-tab
          v-for="(tab, index) in tabs"
          :key="index"
          @click="onTabClick(tab, index)"
          :title="tab.text"
          :active="active(index)"
          title-item-class="lisaweb"
        >
          <keep-alive>
            <component :is="selected"></component>
          </keep-alive>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import Treasuries from "@/components/profile/treasuries-cash-references/treasury/index.vue";
import CashReferences from "@/components/profile/treasuries-cash-references/cash-reference/index.vue";

import ShortcutsAndBreadcrumbsMixin from "@/mixins/ShortcutsAndBreadcrumbsMixin";

export default {
  mixins: [ShortcutsAndBreadcrumbsMixin],
  data() {
    return {
      path: "treasury-cash-reference",
      tabs: [
        { name: "Treasuries", text: "Conti" },
        { name: "CashReferences", text: "Causali" },
      ],
      tabsGroup: "Management",
      // breadcrumbs settings: bcs & maxLevel
      bcs: [
        {
          text: "Configurazione",
          path: "",
          level: 0,
          disabled: true,
        },
        {
          text: "Configurazione",
          path: "",
          level: 1,
        },
        {
          text: "Conti e Causali Contabilità Giornaliera",
          path: "",
          level: 2,
        },
        {
          text: "Conti",
          path: "treasury-cash-reference",
          tab: `#${this.selected}`,
          level: 3,
        },
      ],
      maxLevel: 3, // use to identify the tabs level
      selected: "Treasuries",
      tabIndex: 0,
      // isLoading: false,
    };
  },
  components: {
    Treasuries,
    CashReferences,
  },
};
</script>
